import { FC } from "react";
import { useAppSelector } from "toolkit/hooks";
import cn from "classnames";
import styles from "./ShortHistoryChanges.module.sass";
import Row from "./Row";

interface ShortHistoryChangesProps {
	showHistoryModal: () => void;
}

const ShortHistoryChanges: FC<ShortHistoryChangesProps> = ({ showHistoryModal }) => {
	const selectedOrganization = useAppSelector((state) => state.organizations.selectedOrganization);

	return (
		<div className={styles.popup}>
			<div>
				<div className={styles.tableHead}>
					<div>Редактировали</div>
					<div>Статус</div>
				</div>
				<div>
					{selectedOrganization?.categorizationStatus.history.map((item) => (
						<Row row={item} />
					))}
				</div>
			</div>
			<div className={cn("link", styles.link)} onClick={showHistoryModal}>
				Подробнее
			</div>
		</div>
	);
};

export default ShortHistoryChanges;
